import { dateDiff } from '@wix/da-i18next/pkg/time/functions';
import { editMessageWindow } from '../constants';

export function getCanEditMessage(sentAt: string, isAuthorCurrentUser: boolean) {
  return (
    dateDiff(new Date().toISOString(), sentAt, 'minutes') < editMessageWindow && isAuthorCurrentUser
  );
}
